import { collection, getCountFromServer, getDocs, limit, query, where } from 'firebase/firestore';

import { getFirebaseDb } from '../client';

export interface ExistingConversationMeta {
  id: string;
  messageCount: number;
}

export const getExistingConversationMeta = async (
  uid: string,
  npcId: string,
): Promise<ExistingConversationMeta | null> => {
  const db = getFirebaseDb();
  const conversationQuery = query(
    collection(db, 'conversations'),
    where('userId', '==', uid),
    where('npcId', '==', npcId),
    limit(1),
  );
  const snapshot = await getDocs(conversationQuery);

  if (snapshot.empty) {
    return null;
  }

  const docSnapshot = snapshot.docs[0];
  const data = docSnapshot.data() as { messageCount?: unknown };
  return {
    id: docSnapshot.id,
    messageCount: Number(data.messageCount ?? 0),
  };
};

export const getConversationCount = async (uid: string): Promise<number> => {
  const db = getFirebaseDb();
  const countSnapshot = await getCountFromServer(
    query(collection(db, 'conversations'), where('userId', '==', uid)),
  );
  return countSnapshot.data().count;
};
